import { withStyles } from '@material-ui/styles'
import { alpha } from '@material-ui/core/styles'

// ----------------------------------------------------------------------

const GlobalStyles = withStyles((theme) => ({
  '@global': {
    '*': {
      margin: 0,
      padding: 0,
      boxSizing: 'border-box',
    },
    html: {
      width: '100%',
      height: '100%',
      '-ms-text-size-adjust': '100%',
      '-webkit-overflow-scrolling': 'touch',
    },
    body: {
      width: '100%',
      height: '100%',
      // Thin grayscale smoothing suits light-on-dark; on paper it washes the ink out,
      // so light mode keeps the platform's default (heavier) rendering.
      WebkitFontSmoothing: theme.palette.mode === 'dark' ? 'antialiased' : 'auto',
      MozOsxFontSmoothing: theme.palette.mode === 'dark' ? 'grayscale' : 'auto',
      textRendering: 'optimizeLegibility',
    },
    'code, kbd, pre, samp': {
      fontFamily: theme.typography.fontFamilyMono,
    },
    'a:focus-visible, button:focus-visible, [role="button"]:focus-visible, [tabindex]:not([tabindex="-1"]):focus-visible':
      {
        outline: `2px solid ${theme.palette.primary.main}`,
        outlineOffset: 2,
      },
    '::selection': {
      backgroundColor: alpha(theme.palette.primary.main, 0.24),
    },
    // Thin, low-contrast scrollbars so dense tables keep their edges.
    '*::-webkit-scrollbar': { width: 10, height: 10 },
    '*::-webkit-scrollbar-track': { background: 'transparent' },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: alpha(theme.palette.text.primary, 0.18),
      borderRadius: 8,
      border: `2px solid transparent`,
      backgroundClip: 'content-box',
    },
    '*::-webkit-scrollbar-thumb:hover': {
      backgroundColor: alpha(theme.palette.text.primary, 0.32),
    },
    '#root': {
      width: '100%',
      height: '100%',
    },
    input: {
      '&[type=number]': {
        MozAppearance: 'textfield',
        '&::-webkit-outer-spin-button': { margin: 0, WebkitAppearance: 'none' },
        '&::-webkit-inner-spin-button': { margin: 0, WebkitAppearance: 'none' },
      },
    },
    textarea: {
      '&::-webkit-input-placeholder': { color: theme.palette.text.disabled },
      '&::-moz-placeholder': { opacity: 1, color: theme.palette.text.disabled },
      '&:-ms-input-placeholder': { color: theme.palette.text.disabled },
      '&::placeholder': { color: theme.palette.text.disabled },
    },
    a: { color: theme.palette.primary.main },
    img: { display: 'block', maxWidth: '100%' },

    // Lazy Load Img
    '.blur-up': {
      WebkitFilter: 'blur(5px)',
      filter: 'blur(5px)',
      transition: 'filter 400ms, -webkit-filter 400ms',
    },
    '.blur-up.lazyloaded ': {
      WebkitFilter: 'blur(0)',
      filter: 'blur(0)',
    },
  },
}))(() => null)

export default GlobalStyles
